import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { ReporteAvanceDeComisionesIndividualesService } from '../../services/reporte-avance-de-comisiones-individuales.service';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';


@Component({
  selector: 'app-reporte-avance-de-comisiones-individuales',
  templateUrl: './reporte-avance-de-comisiones-individuales.component.html',
  styleUrls: ['./reporte-avance-de-comisiones-individuales.component.css']
})
export class ReporteAvanceDeComisionesIndividualesComponent implements OnInit {

  tituloForm: string = 'VISUALIZAR AVANCE';

  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  loading: boolean = false;
  modulo: any = {};

  constructor(
    private fb: FormBuilder,
    private _serviciosCRUD: ReporteAvanceDeComisionesIndividualesService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idLiquidacion: ['', []],
      anio: ['', []],
      mes: ['', []],
      tipoVendedorId: ['', []],
      vendedorId: ['', []],
      totalTipoLiquida: ['', []],
      totalEmplLiquida: ['', []],
      totalPagoLiquida: ['', []],
      estadoProceso: ['', []],
      estadoCierre: ['', []],
      usuario: ['', []],
      fechaProceso: ['', []],
      fechaRevision: ['', []],
      mesDescripcion: ['', []],
      // sueldoVariable: ['', []],
    });

    this.getTodo();

  }

  cabecera;
  listVariables;
  listIncentivos;

  getTodo() {

    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.formulario.setValue(res.cabecera);

      this.cabecera = res.cabecera;
      this.listVariables = res.listVariables;
      this.listIncentivos = res.listIncentivos;
    }, (err) => {
      this.loading = false;
    });

  }

}
